export default __webpack_public_path__ + "static/media/mmie.5ccf3bfe.jpg";